import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import * as badges from '../../../../img/nhl/variants/badges';
import { useTheme } from '../../../contexts/ThemeContext';

import styles from '../../../../styles/icons/logos/nhl-cts-horizontal.module.scss';

import ctsLogo from '../../../../img/nhl/logo_cts_horizontal.svg';
import ctsTextLogo from '../../../../img/nhl/logo_cts_text.svg';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function NhlMolsonMvpHorizontal({ className }) {
    const { isVariant } = useTheme();
    const { locale } = useIntl();
    const localeBadges = badges[locale];
    const variants = Object.keys(localeBadges);
    // const variant = 'tor';
    const variant = variants.find((it) => isVariant(it)) || null;
    const badge = variant !== null ? localeBadges[variant] : null;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withBadge]: badge !== null,
                    [className]: className !== null,
                },
            ])}
        >
            {badge !== null ? (
                <img src={badge} className={styles.badge} alt="Molson MVP" />
            ) : null}
            <img
                src={badge !== null ? ctsTextLogo : ctsLogo}
                className={styles.logo}
                alt="Molson MVP"
            />
        </div>
    );
}

NhlMolsonMvpHorizontal.propTypes = propTypes;
NhlMolsonMvpHorizontal.defaultProps = defaultProps;

export default NhlMolsonMvpHorizontal;
